export const publisherswitchConstants = {
    ALL_PUBLISHERS: 'ALL_PUBLISHERS',
    PINNED: 'PINNED',
    

    ALL_PUBLISHERS_NR: 0,
    PINNED_NR: 1,
};